import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyDukQIrcL9kx2OKaLUz1eyvZKAffeuYQGY",
    authDomain: "slack-clone-1e6e0.firebaseapp.com",
    projectId: "slack-clone-1e6e0",
    storageBucket: "slack-clone-1e6e0.appspot.com",
    messagingSenderId: "960715080333",
    appId: "1:960715080333:web:50ee735d477f74a469d8c4"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig)

  const db= firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();


  export {auth, provider};
  export default db;
